import { render, staticRenderFns } from "./AlertData.vue?vue&type=template&id=5d3c636c&scoped=true"
import script from "./AlertData.vue?vue&type=script&lang=js"
export * from "./AlertData.vue?vue&type=script&lang=js"
import style0 from "./AlertData.vue?vue&type=style&index=0&id=5d3c636c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c636c",
  null
  
)

export default component.exports